import { FC } from 'react';

import { List, ListItem, Typography } from '@mui/material';
import { Stack } from '@mui/system';

type PaymentBreakdownInfoProps = {
  title: string;
  details: {
    label: string;
    amount: string;
    highlight?: boolean;
  }[];
};

const PaymentBreakdownInfo: FC<PaymentBreakdownInfoProps> = ({
  title,
  details,
}) => {
  return (
    <div>
      <Typography variant='body1' sx={{ pb: 1 }}>
        {title}
      </Typography>

      <List sx={{ p: 0 }}>
        {details.map((detail, index) => (
          <ListItem key={index} sx={{ p: 0, pb: 1 }}>
            {detail.highlight ? (
              <Stack
                direction='row'
                justifyContent='space-between'
                width='100%'
              >
                <Typography variant='body2' color='text.primary'>
                  {detail.label}
                </Typography>
                <Typography
                  variant='body2'
                  color='text.primary'
                  fontWeight='600'
                >
                  {detail.amount}
                </Typography>
              </Stack>
            ) : (
              <Stack
                direction='row'
                justifyContent='space-between'
                width='100%'
              >
                <Typography variant='body2' color='text.secondary'>
                  {detail.label}
                </Typography>
                <Typography variant='body2' color='text.secondary'>
                  {detail.amount}
                </Typography>
              </Stack>
            )}
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export default PaymentBreakdownInfo;
